export const GOLD   = '#c49832';
export const BLACK  = '#0a0a0a';
export const DARK   = '#111111';
export const DARK2  = '#1a1a1a';